import { History } from 'history';

export const BALANCE_REPLENISHMENT_TRIGGER_PARAM = 'needBalanceReplenishment';

export const addBalanceReplenishmentParamToUrl = (history: History): void => {
    const url = new URL(window.location.href);
    url.searchParams.set(BALANCE_REPLENISHMENT_TRIGGER_PARAM, 'true');
    const newUrl = `${url.pathname}?${url.searchParams.toString()}${url.hash}`;
    history.replace(newUrl);
};

export const deleteBalanceReplenishmentParamFromUrl = (history: History): void => {
    const url = new URL(window.location.href);
    if (url.searchParams.has(BALANCE_REPLENISHMENT_TRIGGER_PARAM)) {
        url.searchParams.delete(BALANCE_REPLENISHMENT_TRIGGER_PARAM);
        const newUrl = `${url.pathname}?${url.searchParams.toString()}${url.hash}`;
        history.replace(newUrl);
    }
};
